import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const CommittedValidate = ({ committed, className = "" }) => {
    const { t } = useTranslation();
    if (committed) return null;

    return (
        <FaInfoCircle
            className={`lumen-glow-icon text-indigo-400 ${className}`}
            title={t("children.common.missing_commitment", { defaultValue: "Nog geen toezegging" })}
        />
    );
};

export default CommittedValidate;
